import { SERVICE, useDeviceInfo } from '@musinsa/packages-device-detection';
import type { FC, PropsWithChildren } from 'react';
import { useAppInterface } from '../../../common';

const INTERNAL_GOTO_PATH_29CM = '/goto/privacy-policy';
const DESTINATION_URL = 'https://www.musinsa.com/member/join/agreement/privacy-policy';

export const GoToMusinsaPrivacyPolicyLink: FC<PropsWithChildren> = ({ children }) => {
  const { isWebview } = useDeviceInfo();
  const { service, methods } = useAppInterface();

  return isWebview ? (
    <button
      className="underline"
      type="button"
      role="link"
      onClick={() => {
        // NOTE: 29CM에서 페이지를 열고 뒤로가기 버튼 클릭 시, 닫기 동작이 되지 않는 이슈로 내부 페이지를 열도록 함
        if (service === SERVICE.MUSINSA) {
          methods.openWebview(DESTINATION_URL);
        }

        if (service === SERVICE['29CM']) {
          methods.openWebview(
            `${process.env.NEXT_PUBLIC_BASE_URL}${INTERNAL_GOTO_PATH_29CM}?29_fullscreen_except_status_bar=true`,
          );
        }
      }}
    >
      {children}
    </button>
  ) : (
    <a href={DESTINATION_URL} target="_blank" rel="noopener noreferrer" className="underline">
      {children}
    </a>
  );
};
